import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import ProfileDesktop from "./ProfileDesktop";
import ProfileMobile from "./ProfileMobile";

export default function Profile() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return isMobile ? <ProfileMobile /> : <ProfileDesktop />;
}
